import { ApplicationRef, Injectable } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { BehaviorSubject, concat, filter, first, fromEvent, interval, Observable } from 'rxjs';

import { LoggerService } from './logger.service';
import { NotifyService } from './notify.service';

@Injectable({
  providedIn: 'root',
})
export class NetworkService {
  private _online: BehaviorSubject<boolean> = new BehaviorSubject(window.navigator.onLine);
  public readonly online: Observable<boolean> = this._online.asObservable();
  public isStandAlone: boolean;
  everySixHoursOnceAppIsStable$: Observable<unknown>;

  constructor(
    private appRef: ApplicationRef,
    private logger: LoggerService,
    private notifySvc: NotifyService,
    private updates: SwUpdate
  ) {
    fromEvent(window, 'online').subscribe(() => {
      this.logger.debug('Network:Online');
      this._online.next(true);
    });
    fromEvent(window, 'offline').subscribe(() => {
      this.logger.debug('Network:Offline');
      this._online.next(false);
    });
    fromEvent(window, 'appinstalled').subscribe(() => {
      this.logger.debug('Network:App:Installed');
      this.isStandAlone = true;
    });
    this.isStandAlone =
      window.navigator.hasOwnProperty('standalone') || window.document.referrer.includes('android-app://');
    this.logger.debug({ 'Network:App:Installed': this.isStandAlone });
    updates.versionUpdates.subscribe(evt => {
      switch (evt.type) {
        case 'VERSION_DETECTED':
          this.logger.debug({ 'Network:Version': evt.version.hash });
          break;
        case 'VERSION_READY':
          this.logger.debug({ 'Network:Version:Current': evt.currentVersion.hash, New: evt.latestVersion.hash });
          this.update();
          break;
        case 'VERSION_INSTALLATION_FAILED':
          this.logger.error({ 'Network:Version': evt.version.hash, Err: evt.error });
          break;
      }
    });
    updates.unrecoverable.subscribe(event => {
      this.logger.error({ 'Network:Unrecoverable': event.reason });
      this.notifySvc.showWarning('Um erro ocorreu. Favor atualizar a página para reestabelecer');
    });

    const appIsStable$ = appRef.isStable.pipe(first(isStable => isStable === true));
    const everySixHours$ = interval(6 * 60 * 60 * 1000);
    this.everySixHoursOnceAppIsStable$ = concat(appIsStable$, everySixHours$);

    this.everySixHoursOnceAppIsStable$.subscribe(async () => {
      try {
        this.logger.debug('Network:Version:Schedule');
        return updates
          .checkForUpdate()
          .then(updateble => {
            if (updateble) {
              this.update();
            } else {
              this.logger.info('Network:Version:Schedule:Updated');
            }
          })
          .catch(err => this.logger.debug({ 'Network:Version:Schedule:Check': err }));
      } catch (err) {
        this.logger.error({ 'Network:Version:Schedule': err });
      }
    });
  }

  public update(): void {
    this.logger.info('Network:Version:Update');
    this.updates.versionUpdates
      .pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'))
      .subscribe(evt => {
        this.logger.info(`Atualizando versão para ${evt.latestVersion.hash}. Reiniciando...`);
        window.document.location.reload();
      });
  }
}
